// extracted by mini-css-extract-plugin
export default {"pecLoading":"PortfolioEntitiesCompaniesLoading_pecLoading__jo7Mz","loadingPortfolioCards":"PortfolioEntitiesCompaniesLoading_loadingPortfolioCards__DDjgn"};